import { fileNameToContentType } from "./file";

export async function uploadFileToBlob({
	fileUrl,
	fileName,
	size,
	requestId,
	uploadContainerBlob
}: {
	fileUrl: string;
	fileName: string;
	size: number;
	requestId: string;
	uploadContainerBlob: (
		requestId: string,
		fileName: string,
		blobContent: Blob,
		contentType: string,
		fileSize: number
	) => Promise<string | undefined>;
}) {
	const blobContent = await fetch(fileUrl).then((response) => response.blob());
	const contentType = fileNameToContentType(fileName);
	const url = await uploadContainerBlob(requestId, fileName, blobContent, contentType, size);
	URL.revokeObjectURL(fileUrl);
	return url;
}
